export function debounce(func: () => Promise<void>, delay: number): () => void {
  let timer: ReturnType<typeof setTimeout>

  return () => {
    clearTimeout(timer)
    timer = setTimeout(() => func(), delay)
  }
}
